import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StylingService, Theme } from 'src/app/services/style-service/styling.service';
import { IframeRecivedService } from 'src/app/shared/navbar/navbar-vesax/iframe-recieved.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-desktop-modal',
  templateUrl: './desktop-modal.component.html',
  styleUrls: ['./desktop-modal.component.scss'],
  standalone:false
})
export class DesktopModalComponent implements OnInit{
  @Input() isOpen = false;
  iframeSrc: SafeResourceUrl='';
  standNeckPath = '';
  standNeckGlowLeftPath = '';
  standNeckGlowRightPath = '';
  standBaseUndersidePath = '';
  standShadowPath = '';

  private readonly svgWidth = 1520;
  private readonly svgHeight = 910;
  private readonly neckSourceMinX = 262;
  private readonly neckSourceMinY = 518;
  private readonly neckSourceWidth = 396;
  private readonly neckSourceHeight = 158;
  /** Viewport width range used to interpolate neck horizontal anchor (matches former breakpoints). */
  private readonly anchorViewportMin = 375;
  private readonly anchorViewportMax = 1920;
  /** At narrow viewports, neck band (min..max) sits more to the right. */
  private readonly anchorMinAtNarrow = 0.38;
  private readonly anchorMaxAtNarrow = 0.42;
  /** At wide viewports, neck band shifts left. */
  private readonly anchorMinAtWide = 0.15;
  private readonly anchorMaxAtWide = 0.2;
  constructor(
    public styleService: StylingService,
    public iframeService:IframeRecivedService,
    private sanitizer: DomSanitizer
  ) { 
    this.iframeSrc = `${environment.designerIframe}home/5-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
  }

  ngOnInit(): void {
    this.iframeService.styleTypeSub.subscribe((styleType) => {
      this.setIframe(styleType ?? 2);
    });
    this.updateStandPaths();
  }

  setIframe(styleType: number) {
    let url =''
    if(styleType===0){
      url = `${environment.designerIframe}home/0-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`
    }else if(styleType===1){
      url = `${environment.designerIframe}home/1-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
    }else if(styleType==5 || styleType==2){
      url = `${environment.designerIframe}home/5-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
    }else if(styleType==6 || styleType==4){
      url = `${environment.designerIframe}home/6-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
    }

    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public get theme(): typeof Theme {
    return Theme;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateStandPaths();
  }

  private updateStandPaths(): void {
    const viewportWidth = window.innerWidth || 1366;
    const minViewport = 375;
    const maxViewport = 1920;
    const viewportRatio = Math.min(Math.max((viewportWidth - minViewport) / (maxViewport - minViewport), 0), 1);

    const leftPercent = this.getResponsiveLeftPercent(viewportWidth);
    const targetLeftX = this.svgWidth * leftPercent;
    const targetTopY = this.svgHeight * 0.91;//0.57
    const widthPercent = 0.25 + viewportRatio * 0.5;//0.05
    const targetWidth = this.svgWidth * widthPercent;
    const targetHeight = this.svgHeight * 0.3;//0.25
    const scaleX = targetWidth / this.neckSourceWidth;
    const scaleY = targetHeight / this.neckSourceHeight;

    const tx = (x: number): number => Math.round((targetLeftX + (x - this.neckSourceMinX) * scaleX) * 100) / 100;
    const ty = (y: number): number => Math.round((targetTopY + (y - this.neckSourceMinY) * scaleY) * 100) / 100;

    this.standNeckPath = `M ${tx(368)} ${ty(518)} H ${tx(555)} Q ${tx(559)} ${ty(549)} ${tx(569)} ${ty(600)} Q ${tx(577)} ${ty(634)} ${tx(599)} ${ty(638)} C ${tx(623)} ${ty(648)} ${tx(658)} ${ty(651)} ${tx(657)} ${ty(663)} Q ${tx(657)} ${ty(672)} ${tx(540)} ${ty(675)} Q ${tx(512)} ${ty(676)} ${tx(460)} ${ty(676)} Q ${tx(408)} ${ty(676)} ${tx(380)} ${ty(675)} Q ${tx(263)} ${ty(672)} ${tx(263)} ${ty(663)} C ${tx(262)} ${ty(651)} ${tx(297)} ${ty(648)} ${tx(321)} ${ty(638)} Q ${tx(343)} ${ty(634)} ${tx(351)} ${ty(600)} Q ${tx(361)} ${ty(550)} ${tx(364)} ${ty(518)} Z`;
    this.standNeckGlowLeftPath = `M ${tx(363)} ${ty(661)} H ${tx(364)} Q ${tx(378)} ${ty(672)} ${tx(379)} ${ty(673)} Q ${tx(263)} ${ty(672)} ${tx(263)} ${ty(663)} C ${tx(262)} ${ty(651)} ${tx(297)} ${ty(648)} ${tx(321)} ${ty(638)} Q ${tx(331)} ${ty(634)} ${tx(334)} ${ty(633)} Z`;
    this.standNeckGlowRightPath = `M ${tx(566)} ${ty(662)} Q ${tx(577)} ${ty(634)} ${tx(599)} ${ty(638)} C ${tx(623)} ${ty(648)} ${tx(658)} ${ty(649)} ${tx(657)} ${ty(663)} Q ${tx(657)} ${ty(672)} ${tx(563)} ${ty(670)} Z`;
    this.standBaseUndersidePath = `M ${tx(263)} ${ty(666)} C ${tx(290)} ${ty(698)}, ${tx(630)} ${ty(698)}, ${tx(657)} ${ty(666)} C ${tx(630)} ${ty(716)}, ${tx(290)} ${ty(716)}, ${tx(263)} ${ty(666)} Z`;
    const shadowTopY = ty(659);
    const shadowTopMidY = ty(705);//668
    const shadowBottomY = ty(740);//740
    this.standShadowPath = `M ${tx(-5)} ${shadowTopY} Q ${tx(460)} ${shadowTopMidY} ${tx(925)} ${shadowTopY} Q ${tx(945)} ${ty(746)} ${tx(460)} ${shadowBottomY} Q ${tx(-25)} ${ty(746)} ${tx(-5)} ${shadowTopY} Z`;
  }

  private getResponsiveLeftPercent(viewportWidth: number): number {
    const t = this.viewportT(
      viewportWidth,
      this.anchorViewportMin,
      this.anchorViewportMax
    );
    const anchorMin = this.lerp(this.anchorMinAtNarrow, this.anchorMinAtWide, t);
    const anchorMax = this.lerp(this.anchorMaxAtNarrow, this.anchorMaxAtWide, t);
    let percent = anchorMin + t * (anchorMax - anchorMin);
    if (viewportWidth > 420) {
      percent -= 0.015;
    }
    if (viewportWidth > 768) {
      percent -= 0.025;
    }
    if (viewportWidth > 900) {
      percent -= 0.0;
    }
    if (viewportWidth > 1024) {
      percent -= 0.015;
    }
    if (viewportWidth > 1100) {
      percent -= 0.012;
    }
    return Math.max(0, percent);
  }

  private viewportT(width: number, minW: number, maxW: number): number {
    return Math.min(Math.max((width - minW) / (maxW - minW), 0), 1);
  }

  private lerp(a: number, b: number, t: number): number {
    return a + (b - a) * t;
  }
}
